import React, { useState, useEffect, useRef } from "react";
import logo from '../Assets/newlogo.png'
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaUserCircle } from 'react-icons/fa';
import { apiGet } from "../API/Api_Url";
import { IoMdNotificationsOutline } from "react-icons/io";
import UserNotificationModel from "../Pages/NotificationModels/UserNotificationModel";
import SupplierNotificationModel from "../Pages/NotificationModels/SupplierNotificationModel";
import LabourNotificationModel from "../Pages/NotificationModels/LabourNotificationModel";
import EngineerNotificationModel from "../Pages/NotificationModels/EngineerNotificationModel";
import ContractorNotificationModel from "../Pages/NotificationModels/ContractorNotificationModel";
import { toast } from "react-toastify";
function Navbar() {
  const navigate = useNavigate()
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileRef = useRef(null);

  const toggleDivRef = useRef(null);
  const handleClickOutside = (event) => {
    if (toggleDivRef.current && !toggleDivRef.current.contains(event.target)) {
      setIsDivVisible(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [open, setOpen] = useState(false);


  const [IsLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const [IsUser, setIsUser] = useState(false);
  const [Iscontractor, setIscontractor] = useState(false);
  const [Issupplier, setIssupplier] = useState(false);
  const [IsfreelanceEngineer, setIsfreelanceEngineer] = useState(false);
  const [Islabour, setlabour] = useState(false);


  useEffect(() => {
    const userType = localStorage.getItem("UserType");
    if (userType === "User") {
      setIsUser(true);
    }
    if (userType === "contractor") {
      setIscontractor(true);
    }
    if (userType === "supplier") {
      setIssupplier(true);
    }
    if (userType === "freelanceEngineer") {
      setIsfreelanceEngineer(true);
    }
    if (userType === "labour") {
      setlabour(true);
    }
  }, []);

  const [AllNotification, setAllNotification] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);

  const GetAllNotification = async () => {
    try {
      setIsUploading(true);
      let endpoint = '';

      if (IsUser) endpoint = 'api/user/GetAllNotification';
      else if (Iscontractor) endpoint = 'api/contractor/GetAllNotification';
      else if (IsfreelanceEngineer) endpoint = 'api/freelance-engineer/GetAllNotification';
      else if (Issupplier) endpoint = 'api/material-supplier/SupplierGetAllNotification';
      else if (Islabour) endpoint = 'api/labour/LabourGetAllNotification';

      if (!endpoint) return;

      const response = await apiGet(endpoint);
      setAllNotification(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    if (IsLoggedIn) {
      GetAllNotification();
    }
  }, [IsLoggedIn, IsUser, Iscontractor, Issupplier, IsfreelanceEngineer, Islabour]);




  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const CloseNotificationmodel = () => {
    setIsNotifOpen(false)
  }

  const [openmenu, setOpenmenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenmenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);


  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userToken');
    localStorage.removeItem('UserType');
    toast.success('Logout Successful');
    navigate('/');
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  const [selectedLang, setSelectedLang] = useState("English");
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);

  // const handleLanguageChange = (code, label) => {
  //   setSelectedLang(label);
  //   setLangOpen(false);

  //   const select = document.querySelector('.goog-te-combo');
  //   if (select) {
  //     select.value = code;
  //     select.dispatchEvent(new Event('change', { bubbles: true }));
  //     return;
  //   }
  //   setTimeout(() => {
  //     try {
  //       const googleFrame = document.querySelector('.goog-te-menu-frame:not([style*="display: none"])');

  //       if (!googleFrame) {
  //         console.log('Google Translate frame not found');
  //         return;
  //       }

  //       const innerDoc = googleFrame.contentDocument || googleFrame.contentWindow.document;

  //       const languageOptions = innerDoc.querySelectorAll('.goog-te-menu2-item span.text');

  //       languageOptions.forEach((option) => {
  //         const text = option.textContent || option.innerText;
  //         if (text && text.includes(label)) {
  //           option.click();
  //         }
  //       });
  //     } catch (error) {
  //       console.error('Error changing language:', error);
  //     }
  //   }, 1000); 
  // };

  useEffect(() => {
    const savedLang = localStorage.getItem('selectedLanguage');
    const savedLangCode = localStorage.getItem('selectedLanguageCode');

    if (savedLang && savedLangCode) {
      setSelectedLang(savedLang);

      const applyLanguage = () => {
        const select = document.querySelector('.goog-te-combo');
        if (select) {
          if (select.value !== savedLangCode) {
            select.value = savedLangCode;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          setTimeout(applyLanguage, 500);
        }
      };

      setTimeout(applyLanguage, 1500);
    }
  }, []);

  const handleLanguageChange = (code, label) => {
    setSelectedLang(label);
    setLangOpen(false);

    localStorage.setItem('selectedLanguage', label);
    localStorage.setItem('selectedLanguageCode', code);

    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = code;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    setTimeout(() => {
      try {
        const googleFrame = document.querySelector('.goog-te-menu-frame:not([style*="display: none"])');

        if (!googleFrame) {
          console.log('Google Translate frame not found');
          return;
        }

        const innerDoc = googleFrame.contentDocument || googleFrame.contentWindow.document;
        const languageOptions = innerDoc.querySelectorAll('.goog-te-menu2-item span.text');

        languageOptions.forEach((option) => {
          const text = option.textContent || option.innerText;
          if (text && text.includes(label)) {
            option.click();
          }
        });
      } catch (error) {
        console.error('Error changing language:', error);
      }
    }, 1000);
  };

  return (
    <>
      <div className='navbar'>
        <nav>
          <img src={logo} alt="logo" />
          <ul className="desktop-menu flex gap-6">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `none2 relative px-2 py-1 ${isActive
                  ? "text-gray-900 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-red-500"
                  : "text-gray-600 hover:text-gray-900"
                }`
              }
            >
              <li>Home</li>
            </NavLink>

            {/* <NavLink
              to="/AboutUs"
              className={({ isActive }) =>
                `none2 relative px-2 py-1 ${isActive
                  ? "text-gray-900 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-red-500"
                  : "text-gray-600 hover:text-gray-900"
                }`
              }
            >
              <li>About Us</li>
            </NavLink> */}

            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `none2 relative px-2 py-1 ${isActive
                  ? "text-gray-900 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-red-500"
                  : "text-gray-600 hover:text-gray-900"
                }`
              }
            >
              <li>Contact Us</li>
            </NavLink>
            <NavLink
              to="/terms"
              className={({ isActive }) =>
                `none2 relative px-2 py-1 ${isActive
                  ? "text-gray-900 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-red-500"
                  : "text-gray-600 hover:text-gray-900"
                }`
              }
            >
              <li>Terms and Conditions</li>
            </NavLink>

            <NavLink
              to="/privacypolicy"
              className={({ isActive }) =>
                `none2 relative px-2 py-1 ${isActive
                  ? "text-gray-900 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[3px] after:rounded after:bg-gradient-to-r after:from-blue-500 after:to-red-500"
                  : "text-gray-600 hover:text-gray-900"
                }`
              }
            >
              <li>Privacy Policy</li>
            </NavLink>
          </ul>


          <div className="navbtns desktop-menu flex items-center gap-4">
            {IsLoggedIn && (
              <div className="relative">
                <IoMdNotificationsOutline
                  size={28}
                  className="cursor-pointer text-gray-600 hover:text-gray-800 transition"
                  onClick={() => setIsNotifOpen(true)}
                />
                {AllNotification?.filter((n) => !n?.Isread)?.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                    {AllNotification?.filter((n) => !n?.Isread)?.length}
                  </span>
                )}
              </div>
            )}
            <div className="relative" ref={langRef}>
              <div
                onClick={() => setLangOpen(!langOpen)}
                className="cursor-pointer p-[2px] rounded-full bg-gradient-to-r from-green-500 to-purple-500"
              >
                <div className="bg-white rounded-full px-3 py-[6px] text-sm font-medium text-gray-800">
                  {selectedLang}
                </div>
              </div>

              {langOpen && (
                <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-xl p-2 border border-gray-100 animate-fadeIn">
                  {[
                    { label: "English", code: "en" },
                    { label: "हिन्दी (Hindi)", code: "hi" },
                    { label: "ಕನ್ನಡ (Kannada)", code: "kn" }
                  ].map((item) => (
                    <button
                      key={item.code}
                      className={`w-full text-left px-3 py-2 rounded-lg hover:bg-gray-100 ${selectedLang === item.label ? "bg-gray-100 font-semibold" : ""
                        }`}
                      onClick={() => handleLanguageChange(item.code, item.label)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )}
            </div>


            <>
              {IsLoggedIn ? (
                <div className="relative" ref={menuRef}>
                  <div
                    onClick={() => setOpenmenu(!openmenu)}
                    className="cursor-pointer p-[2px] rounded-full bg-gradient-to-r from-blue-500 to-red-500"
                  >
                    <div className="bg-white rounded-full p-[2px]">
                      <FaUserCircle size={28} className="text-gray-800" />
                    </div>
                  </div>
                  {openmenu && (
                    <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-xl p-2 border border-gray-100 animate-fadeIn">
                      <button
                        className="w-full text-left px-3 py-2 rounded-lg hover:bg-gray-100"
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>

                      <button
                        className="w-full text-left px-3 py-2 rounded-lg hover:bg-red-50 text-red-600"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <button className="signup" onClick={() => navigate('/SignUpSelection')}>
                    Sign Up
                  </button>
                  <button className="login" onClick={() => navigate('/LoginSelection')}>
                    Log In
                  </button>
                </>
              )}
            </>
          </div>

          <i className="bi bi-list hamburger-icon" onClick={() => setOpen(true)}></i>

        </nav>
        <div className={`side-menu ${open ? 'show' : ''}`}>
          <i className="bi bi-x close-icon" onClick={() => setOpen(false)}></i>
          <ul className="side-menu-ul">
            <Link className="none2" to='/'><li onClick={() => setOpen(false)}>Home</li></Link>
            <li onClick={() => setOpen(false)}>About Us</li>
            <li onClick={() => setOpen(false)}>How It Works</li>
            <li onClick={() => setOpen(false)}>Services</li>
            <li onClick={() => setOpen(false)}>Emergency Fund</li>
            <Link className="none2" to='/contact'><li onClick={() => setOpen(false)}>Contact Us</li></Link>
          </ul>
          <div className='navbtns navbtns2'>
            {IsLoggedIn ? (
              <FaUserCircle
                size={32}
                style={{ cursor: "pointer" }}
                onClick={() => navigate('/profile')}
              />
            ) : (<>
              <button className='signup' onClick={() => { navigate('/SignUpSelection') }}>Sign Up</button>
              <button className='login' onClick={() => { navigate('/LoginSelection') }}>Log In</button>
            </>
            )}
          </div>
        </div>
      </div>
      {isDivVisible && (
        <div className="toggleDiv-ops">
          <div className="toggleDiv" ref={toggleDivRef}>
            <ul>
              <li>
                <NavLink className='none' exact activeClassName="active" to="/">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink className='none' activeClassName="active" to="/">
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink className='none' activeClassName="active" to="/">
                  How Its Work
                </NavLink>
              </li>
              <li>
                <NavLink className='none' activeClassName="active" to="/">
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink className='none' activeClassName="active" to="/">
                  Emergency Fund
                </NavLink>
              </li>
              <li>
                <NavLink className='none' activeClassName="active" to="/">
                  Contact Us
                </NavLink>
              </li>
              <img src={logo} />
            </ul>
          </div>
        </div>
      )}
      {IsUser && (
        <UserNotificationModel
          isOpen={isNotifOpen}
          onClose={() => CloseNotificationmodel()}
          notifications={AllNotification}
          GetAllNotification={GetAllNotification}
        />
      )}
      {Issupplier && (
        <SupplierNotificationModel
          isOpen={isNotifOpen}
          onClose={() => CloseNotificationmodel()}
          notifications={AllNotification}
          GetAllNotification={GetAllNotification}
        />
      )}
      {Islabour && (
        <LabourNotificationModel
          isOpen={isNotifOpen}
          onClose={() => CloseNotificationmodel()}
          notifications={AllNotification}
          GetAllNotification={GetAllNotification}
        />
      )}
      {IsfreelanceEngineer && (
        <EngineerNotificationModel
          isOpen={isNotifOpen}
          onClose={() => CloseNotificationmodel()}
          notifications={AllNotification}
          GetAllNotification={GetAllNotification}
        />
      )}
      {Iscontractor && (
        <ContractorNotificationModel
          isOpen={isNotifOpen}
          onClose={() => CloseNotificationmodel()}
          notifications={AllNotification}
          GetAllNotification={GetAllNotification}
        />
      )}
    </>
  )
}

export default Navbar